// ⭐ Scroll only to the question …
document.addEventListener("DOMContentLoaded", () => {
  const faqItems = document.querySelectorAll(".faqrs-item");

  faqItems.forEach(item => {
    const question = item.querySelector(".faqrs-question");
    const answer = item.querySelector(".faqrs-answer");

    question.addEventListener("click", () => {
      const isActive = item.classList.contains("faqrs-active");

      // Close all items
      faqItems.forEach(i => {
        i.classList.remove("faqrs-active");
        i.querySelector(".faqrs-answer").style.maxHeight = null;
        i.querySelector(".faqrs-question").setAttribute("aria-expanded", "false");
      });

      // Open clicked item
      if (!isActive) {
        item.classList.add("faqrs-active");
        answer.style.maxHeight = answer.scrollHeight + "px";
        question.setAttribute("aria-expanded", "true");
      }
    });
  });
});





function refreshedCartDrawer(){
  fetch('/?sections=cart-drawer,cart-icon-bubble')
  .then(res => res.json())
  .then(data => {
    const parsedHTML = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
    const drawerInner = parsedHTML.querySelector('.drawer__inner');
    const isEmpty = drawerInner?.classList.contains('is-empty');
    console.log('isEmpty: ',isEmpty);
    const parsedState = {
      sections: {
        'cart-drawer': data['cart-drawer'],
        'cart-icon-bubble': data['cart-icon-bubble']
      },
      id: null
    };
    const cartDrawer = document.querySelector('cart-drawer');
    if(!isEmpty){
      cartDrawer.classList.remove('is-empty');
      cartDrawer.renderContents(parsedState);
    }
  });
  
}

